// extracted by mini-css-extract-plugin
export default {"input":"a8-z","button":"b8-z","selected":"c8-z","unavailable":"d8-z","oos":"e8-z","image":"f8-z","paperCutDisabledOverlay":"g8-z"};